<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col class="text-right mb-4">
        Filters : 
          <date-range-picker
            ref="picker"
            :opens="'left'"
            v-model="filters.selectedDate"
            @update="updateFilter">
              <template v-slot:input="picker" style="min-width: 350px;">
                  {{getDisplayDateFiltered(picker.startDate)}} - {{ getDisplayDateFiltered(picker.endDate)}}
              </template>
          </date-range-picker>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="col-12 col-md-6">
        <b-card header="Revenue">
          <b-row>
            <b-col sm="6" lg="6">
              <b-card no-body class="bg-primary">
                <b-card-body class="pb-0">
                  <h4 class="mb-0">{{revenueData.totalAmount || 0}}</h4>
                  <p><b>Revenue</b></p>
                </b-card-body>
                <card-line1-chart-example chartId="card-chart-01" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
              </b-card>
            </b-col>
            <b-col sm="6" lg="6">
              <b-card no-body class="bg-info">
                <b-card-body class="pb-0">
                  <h4 class="mb-0">{{revenueData.totalOrders || 0}}</h4>
                  <p>Total Orders</p>
                </b-card-body>
                <card-line2-chart-example chartId="card-chart-02" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
              </b-card>
            </b-col>
            <b-col sm="6" lg="6">
              <b-card no-body class="bg-warning">
                <b-card-body class="pb-0">
                  <h4 class="mb-0">{{revenueData.orderMinAmount || 0}}</h4>
                  <p>Min. Order Amount</p>
                </b-card-body>
                <card-line3-chart-example chartId="card-chart-03" class="chart-wrapper" style="height:70px;" height="70"/>
              </b-card>
            </b-col>
            <b-col sm="6" lg="6">
              <b-card no-body class="bg-danger">
                <b-card-body class="pb-0">
                  <h4 class="mb-0">{{revenueData.orderMaxAmount || 0}}</h4>
                  <p>Max. Order Amount</p>
                </b-card-body>
                <card-bar-chart-example chartId="card-chart-04" class="chart-wrapper px-3" style="height:70px;" height="70"/>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col class="col-12 col-md-6">
        <b-card header="Models Info">
          <pie-example v-if="pieData.data && pieData.data.length" class="col-12 col-lg-10 m-auto" chartId="soch3d-pieChart-1"  :backgroundColors="pieData.backgroundColors" :labels="pieData.labels" :chartData="pieData.data"/>
          <div class="text-center" v-else> No Model Data Found!</div>
        </b-card>
      </b-col>
      <b-col class="col-12 col-md-6">
        <b-card header="Newly Registered Users">
          <div v-if="newUsersData && newUsersData.users && newUsersData.users.length">
            <b-table  :hover="true" :striped="true" :bordered="true" :small="true" :fixed="true" responsive="sm" :items="newUsersData.users" :fields="newUsersData.fields" :current-page="newUsersData.currentPage" :per-page="newUsersData.perPage" >
              <template slot="id" slot-scope="data">
                {{data.item.id}}
              </template>
              <template slot="username" slot-scope="data">
                {{data.item.username}}
              </template>
              <template slot="email" slot-scope="data">
                {{data.item.email}}
              </template>
              <template slot="createdAt" slot-scope="data">
                {{new Date(data.item.createdAt).toDateString()}}
              </template>
            </b-table>
            <nav>
              <b-pagination size="sm" :total-rows="getRowCount(newUsersData.users)" :per-page="newUsersData.perPage" v-model="newUsersData.currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </div>
          <div class="text-center" v-else> No New Users Found Yet!</div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import CardLine1ChartExample from './../dashboard/CardLine1ChartExample'
import CardLine2ChartExample from './../dashboard/CardLine2ChartExample'
import CardLine3ChartExample from './../dashboard/CardLine3ChartExample'
import CardBarChartExample from './../dashboard/CardBarChartExample'
import PieExample from './../charts/PieExample';

export default {
  name: 'dashboard',
  components: {
    PieExample,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
    CardBarChartExample,
    DateRangePicker
  },
  mounted(){
    this.updateDashboard();
  },
  data(){
    return {
      filters:{
        selectedDate:{
          startDate: new Date(),
          endDate: new Date()
        },
      },
      pieData: {},
      revenueData:{},
      newUsersData:{
        users: [],
        fields: [
          {key: 'id'},
          {key: 'username'},
          {key: 'email'},
          {key: 'createdAt'}
        ],
        currentPage: 1,
        perPage: 5,
        totalRows: 0
      }
    }
  },
  methods:{
    getDisplayDateFiltered: function(dateSelected){
      let selecteddate = dateSelected ? new Date(dateSelected) : new Date(); 
      let dd = selecteddate.getDate(),
          mm = selecteddate.getMonth() + 1,
          yyyy = selecteddate.getFullYear(); 
      if (dd < 10) dd = '0' + dd; 
      if (mm < 10) mm = '0' + mm; 
      return dd + '/' + mm + '/' + yyyy;
    },
    updateFilter:function(updatedDate){
      this.filters.selectedDate = updatedDate;
      this.updateDashboard();
    },
    updateDashboard: async function(){
      let {selectedDate} = this.filters;
      selectedDate.startDate=new Date(selectedDate.startDate).toISOString();
      selectedDate.endDate=new Date(selectedDate.endDate).toISOString();
      selectedDate.startDate = selectedDate.startDate.replace(selectedDate.startDate.substr(selectedDate.startDate.indexOf('T')+1),'00:00:00.000Z');
      selectedDate.endDate = selectedDate.endDate.replace(selectedDate.endDate.substr(selectedDate.endDate.indexOf('T')+1),'18:29:59.000Z');
      
      //  Reset Current Data;
      let query='';
      this.pieData = {
        backgroundColors:[],
        data:[],
        labels:[]
      };

      if(selectedDate.startDate==selectedDate.endDate){
        query+='createdAt_gte='+selectedDate.startDate;
      }else{
        query+='createdAt_gte='+selectedDate.startDate;
        query+='&createdAt_lte='+selectedDate.endDate;
      }

      // UPDATE REVENUE BLOCK
      let revenue = await this.strapi.axios.get('/analytics/revenue'+(query ? '?'+query : ''));
      if(revenue && revenue.data) this.revenueData=revenue.data;

      // UPDATE MODELS BLOCK
      let models = await this.strapi.axios.get('/analytics/models'+(query ? '?'+query : ''));
      if(models && models.data){
        let {totalModels,slicedModels,slicefailedModels,slicePendingModels,modelsWithQuote,modelswithCartItems,modelsWithoutCartItems,modelswithFilesUploaded,modelswithoutFiles} = models.data;
        if(totalModels || slicedModels || slicefailedModels || slicePendingModels || modelsWithQuote || modelswithCartItems || modelsWithoutCartItems || modelswithFilesUploaded || modelswithoutFiles){
          this.updatePieChart('Total models','#41B883',totalModels);
          this.updatePieChart('Files uploaded','#f8cb00',modelswithFilesUploaded);
          this.updatePieChart('Sliced','#E46651',slicedModels);
          this.updatePieChart('Failed','#00D8FF',slicefailedModels);
          this.updatePieChart('Pending','#DD1B16',slicePendingModels);
          this.updatePieChart('CartItems','#17a2b8',modelswithCartItems);
          this.updatePieChart('Quote','#e83e8c',modelsWithQuote);
          this.updatePieChart('Manual Quote','#6610f2',modelswithCartItems-modelsWithQuote);
          // this.updatePieChart('Without Files','#6610f2',modelswithoutFiles);
          // this.updatePieChart('Without CartItem','#20c997',modelsWithoutCartItems);
        }
      }

      // UPDATE NEW USERS
      let newUsers = await this.strapi.axios.get('/analytics/newusers'+(query ? '?_sort=createdAt:desc&'+query : ''));
      if(newUsers && newUsers.data){
        this.newUsersData.users=newUsers.data;
        this.newUsersData.totalRows=this.newUsersData.users.length;
      }
      console.log(this.newUsersData.users);
    },
    getRowCount (items) {
      return items.length
    },
    updatePieChart(label,color,value){
      this.pieData.labels.push(label);
      this.pieData.backgroundColors.push(color);
      this.pieData.data.push(value);
    }
  }
}
</script>

<style>
  
</style>
